<template>
    <div class="block-session-expired">
        <ejs-dialog id="expired" ref="Expired" :header="$t('textSessionExpired.textHeader')" :isModal='isModal' :target='target' :buttons='buttons' :visible='visible' :content="$t('textSessionExpired.textBody')"></ejs-dialog>
    </div>
</template>
<script>

import { DialogPlugin } from '@syncfusion/ej2-vue-popups';
Vue.use(DialogPlugin);

export default {
    name: 'session-expired',
    data() {
        return {
            target: "#app",
            isModal: true,
            visible: false,
            buttons: [{ click: this.dlgButtonClick, buttonModel: { content: 'Aceptar', isPrimary: true } }],
        }
    },
    methods: {
        dlgButtonClick: function() {
            //borrar token de localstorage
            localStorage.removeItem('access_token');
            this.$router.push({ name: 'login' });
        },
    },
}
</script>